import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './sass_ribbon.sass';
export function SassRibbon({ text = 'Sass (indented) brings sugar' }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "sass-ribbon",
        "data-kind": "sass",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "sass-ribbon__token",
                children: "sass"
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "sass-ribbon__text",
                children: text
            })
        ]
    });
}


export const knightedCss = ".sass-ribbon,.knighted-sass-ribbon{color:#0f172a;background:linear-gradient(135deg,#ec4899,#c084fc);border-radius:999px;align-items:center;gap:.5rem;padding:.7rem 1.2rem;font-weight:700;display:inline-flex;box-shadow:0 15px 40px #c084fc4d}.sass-ribbon__token,.knighted-sass-ribbon__token{color:#f9a8d4;text-transform:uppercase;letter-spacing:.08em;background:#0f172a;border-radius:12px;padding:.25rem .75rem;font-size:.85rem}.sass-ribbon__text,.knighted-sass-ribbon__text{font-size:1rem}";
